export default __webpack_public_path__ + "static/Plots0094-cb58bd7c1fa39a2b6544b9d3c99762f0.jpg";